import { useEffect, useState } from "react"

interface UseButtonSingleSelectProps {
  options: Array<{ title: string; id: string }>
  defaultValue: string
  onSubmit: (selectedValue: string) => Promise<void>
}

export default function useButtonSingleSelect({ options, defaultValue = null, onSubmit }: UseButtonSingleSelectProps) {
  const [valid, setValid] = useState(false)
  const [selected, setSelected] = useState(null)
  const [loading, isLoading] = useState(false)

  useEffect(() => {
    setSelected(options.find(({ id }) => id === defaultValue)?.id)
    if (defaultValue !== null) {
      setValid(true)
    }
  }, [])

  async function onClick(selectedValue) {
    setSelected(selectedValue)
    isLoading(true)
    try {
      await onSubmit(selectedValue)
    } catch {
      isLoading(false)
    }
    isLoading(false)
    setValid(true)
  }

  return { options, valid, selected, onClick, loading }
}
